import React from "react";
import { RouteObject } from "../../interfaces/navigation";

const EntryPoint = React.lazy(() => import("./index"));

export const notFoundPageRoutes: RouteObject[] = [
    {
        title: "notFound",
        path: "/notFound",
        component: <EntryPoint />
    }
];